export function BannerItem(
  id = '',
  file = '',
  dim = '',
  caption = '',
  link_web = '',
  link_app = '',
  order = ''
) {
  this.id = id;
  this.file = file;
  this.dim = dim;
  this.caption = caption;
  this.link_web = link_web;
  this.link_app = link_app;
  this.order = order;
}
